import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/modules/shared/shared.module';
import { AuthenticationModule } from '../authentication/modules/authentication/authentication.module';
import { CardEntryComponent } from './components/common/card-entry/card-entry.component';
import { AddMfaDialogComponent } from './components/dialogs/add-mfa-dialog/add-mfa-dialog.component';
import { EmailChangedDialogComponent } from './components/dialogs/email-changed-dialog/email-changed-dialog.component';
import { RemoveMfaDialogComponent } from './components/dialogs/remove-mfa-dialog/remove-mfa-dialog.component';
import { EditMfaComponent } from './components/exported/edit-mfa/edit-mfa.component';
import { EditNamesComponent } from './components/exported/edit-names/edit-names.component';

const declarations = [
  AddMfaDialogComponent,
  RemoveMfaDialogComponent,
  EditNamesComponent,
  EditMfaComponent,
  CardEntryComponent,
  EmailChangedDialogComponent,
];

@NgModule({
  imports: [CommonModule, SharedModule, AuthenticationModule],
  declarations,
  exports: declarations,
})
export class EditProfileModule {}
